import React from "react";
import { Container, Table } from "react-bootstrap";
import Seo from "../components/Seo/Seo";
import "./styles/legal.css";

const PolitiqueConfidentialite = () => {
  return (
    <Container className="legal--main">
      <Seo
        title="Politique de confidentialité | Makni Renov' - Rénovation Paris 12"
        description="Politique de confidentialité de maknirenov.com : données collectées par le formulaire de contact, finalités, durées de conservation et exercice de vos droits (RGPD)."
        path="/politique-confidentialite"
      />
      <h1>Politique de confidentialité</h1>

      <h2>Responsable du traitement</h2>
      <p>
        La société MAKNI (Makni Renov'), SAS, 101 boulevard Poniatowski, 75012
        Paris, représentée par M. Wissem Makni. Contact : maknirenov@gmail.com.
      </p>

      <h2>Données collectées</h2>
      <ul>
        <li>
          Via le formulaire de contact : nom, adresse e-mail, sujet et message.
        </li>
        <li>
          Données techniques : adresse IP et journaux de connexion, conservés
          par l'hébergeur pour la sécurité du site.
        </li>
      </ul>

      <h2>Finalités et bases légales</h2>
      <Table bordered responsive>
        <thead>
          <tr>
            <th>Finalité</th>
            <th>Base légale (RGPD, art. 6)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Répondre aux demandes de devis et de contact</td>
            <td>Mesures précontractuelles (art. 6.1.b)</td>
          </tr>
          <tr>
            <td>Gérer la relation client et le suivi des chantiers</td>
            <td>Exécution du contrat (art. 6.1.b)</td>
          </tr>
          <tr>
            <td>Assurer la sécurité et le bon fonctionnement du site</td>
            <td>Intérêt légitime (art. 6.1.f)</td>
          </tr>
        </tbody>
      </Table>
      <p>
        Vos données ne sont jamais vendues ni utilisées à des fins publicitaires.
      </p>

      <h2>Destinataires</h2>
      <p>
        Les données sont accessibles uniquement au personnel de Makni Renov' et
        à ses prestataires techniques (hébergeur, service d'envoi des messages
        EmailJS, messagerie), dans la limite de leurs missions.
      </p>

      <h2>Durées de conservation</h2>
      <ul>
        <li>Demande sans suite : 3 ans à compter du dernier contact.</li>
        <li>
          Clients : durée de la relation, puis conservation des documents
          comptables et contractuels pendant les durées légales (10 ans).
        </li>
        <li>Journaux de connexion : 12 mois maximum.</li>
      </ul>

      <h2>Transferts hors de l'Union européenne</h2>
      <p>
        Le site est hébergé par GitHub, Inc. aux États-Unis, et les messages du
        formulaire transitent par un prestataire d'envoi de courriels. Ces
        transferts sont encadrés par le Data Privacy Framework ou par des
        clauses contractuelles types de la Commission européenne.
      </p>

      <h2>Cookies</h2>
      <p>Le site n'utilise aucun cookie publicitaire ni de suivi.</p>

      <h2>Vos droits</h2>
      <p>
        Vous disposez d'un droit d'accès, de rectification, d'effacement, de
        limitation, d'opposition et de portabilité de vos données. Pour les
        exercer, écrivez à maknirenov@gmail.com ou au 101 boulevard Poniatowski,
        75012 Paris, en précisant votre demande. Une réponse vous sera apportée
        sous un mois.
      </p>
      <p>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez
        adresser une réclamation à la CNIL (
        <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">
          cnil.fr
        </a>
        ).
      </p>

      <h2>Mise à jour</h2>
      <p>Dernière mise à jour : 8 octobre 2026.</p>
    </Container>
  );
};

export default PolitiqueConfidentialite;
